import { dataPhoneEyeSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPhoneEyeSolid = /*#__PURE__*/createIcon(dataPhoneEyeSolid)
export default IconPhoneEyeSolid
